import { createContext, useContext } from 'react';
import { AdditionalCurrency, Currency, Units } from 'common/types/format';

export interface WaterfallFXContextType {
  currencyDisplayLabel: string;
  selectedCurrency: AdditionalCurrency | null;
  setSelectedCurrency: (currency: AdditionalCurrency) => void;
  exchangeRate: number | null;
  currencyList: AdditionalCurrency[];
  isLoading: boolean;
  onCurrencyChange: (currency: Currency) => void;
  onUnitsChange: () => void;
  standardCurrency: string | undefined;
  unitDisplayLabel: string;
  units: Units;
}

export const WaterfallFXContext = createContext<WaterfallFXContextType | undefined>(undefined);

export const useWaterfallFXContext = () => useContext(WaterfallFXContext);
